module.exports = __webpack_public_path__ + "img/USDT-logo.eac1f7bb.svg";